/**
 * Utility functions for handling SOP (Standard Operating Procedure) data.
 */
import { auth0Claims } from '../auth/consts'

export const getUserOrganization = (user) => {
  return (user && user[auth0Claims.userAuthClaim]?.user_metadata?.Organization) || null
}
